import { Telemetry, TelemetryOptions, getTelemetry as getTelemetryFirebase } from "@firebase/telemetry";
import { FirebaseApp, initializeApp, getApps, getApp } from "@firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from '@firebase/app-check';

let app: FirebaseApp | null = null;
let _telemetry: Telemetry | undefined;

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: "ali-crash-test.firebaseapp.com",
  projectId: "ali-crash-test",
  storageBucket: "ali-crash-test.firebasestorage.app",
  messagingSenderId: "560821244751",
  appId: "1:560821244751:web:c66d7e685fbe4ca600eb3a"
};

export const telemetryOptions: TelemetryOptions = {
  endpointUrl: process.env.NEXT_PUBLIC_OTEL_ENDPOINT
};

export function initFirebase() {
  if (app) {
    return app;
  }

  app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
}

export function initAppCheck() {
  if (!app) initFirebase();

  if (app && typeof window !== 'undefined') {
    const siteKey = process.env.NEXT_PUBLIC_FIREBASE_APP_CHECK_KEY;
    if (siteKey) {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });
      console.log("App Check intialized");
    } else {
      console.error("Missing NEXT_PUBLIC_FIREBASE_APP_CHECK_KEY environment variable.");
    }
  }
}

export function getTelemetry(): Telemetry {
  if (!_telemetry) {
    _telemetry = getTelemetryFirebase(getApp(), telemetryOptions);
  }
  return _telemetry;
}

export {app};
